
import {SafeAreaView} from 'react-native-safe-area-context';

import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled(SafeAreaView)`
  flex: 1;
  justify-content: center;
  background-color: ${({theme}) => theme.colors.background};
  align-items: center;
`;

export const MaintenanceContent = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const MaintenanceTitle = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(6)}px;
  margin-top: ${RFValue(16)}px;
`;

export const MaintenanceText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_dark};
  text-align: center;
`;

export const Footer = styled.View`
  padding: 0 24px;
 
  width: 100%;
`;
